import styled from 'styled-components';

export const Container = styled.div`
  padding-top: 150px;

  @media only screen and (max-width: 850px) {
    padding-top: 90px;
  }
`;

export const DescriptionContainer = styled.div`
  margin: 0 auto;
  padding: 0px 20px;
  max-width: 1200px;

  display: flex;
  justify-content: space-between;

  padding-bottom: 150px;

  @media only screen and (max-width: 850px) {
    flex-direction: column;
    align-items: center;
    padding-bottom: 50px;
  }
`;

export const DescriptionItem = styled.div`
  text-align: center;
  max-width: 500px;

  h4 {
    margin-bottom: 20px;
    font-weight: 800;
    font-size: 30px;
    line-height: 45px;
    text-align: center;

    color: #000000;
  }

  span {
    font-weight: normal;
    font-size: 18px;
    line-height: 27px;
    text-align: center;

    color: #272727;
  }

  @media only screen and (max-width: 850px) {
    span {
      font-size: min(5vw, 18px);
    }

    & + div {
      margin-top: 50px;
    }
  }
`;

export const Content = styled.div`
  margin: 0 auto;
  padding: 0px 20px;
  max-width: 800px;

  h1 {
    font-weight: 800;
    font-size: 90px;
    line-height: 135px;
    text-align: center;
    padding-bottom: 30px;

    color: #199ec6;
  }

  p {
    font-size: 18px;
    line-height: 27px;
    text-align: center;

    color: #272727;
  }

  @media only screen and (max-width: 850px) {
    p {
      text-align: justify;
    }

    h1 {
      font-size: 17vw;
      padding-bottom: 0px;
    }
  }
`;

export const JobsList = styled.div`
  display: flex;
  justify-content: space-between;

  margin: 0 auto;
  max-width: 1200px;

  padding: 150px 10px;

  img {
    width: 198px;
  }

  @media only screen and (max-width: 850px) {
    flex-direction: column;
    align-items: center;

    padding: 100px 10px;

    div {
      & + div {
        margin-top: 20px;
      }
    }
  }
`;

export const JobItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  max-width: 200px;
  height: 200px;

  span {
    margin-top: 25px;
    font-weight: 800;
    font-size: 25px;
    line-height: 45px;
    text-align: center;

    color: #272727;
  }
`;

export const ContainerInfos = styled.div`
  margin: 0 auto;
  padding: 10px 10px;
  padding-top: 130px;
  padding-bottom: 280px;

  display: flex;
  max-width: 1200px;

  justify-content: space-between;

  a {
    font-weight: 800;
    font-size: 20px;
    line-height: 30px;
    text-decoration: none;

    color: #000000;

    transition: color 0.2s;

    :hover {
      color: #386882;
    }
  }

  h1 {
    font-weight: 800;
    font-size: 60px;
    line-height: 90px;

    color: #199ec6;
  }

  @media only screen and (max-width: 850px) {
    text-align: center;
    flex-direction: column;
    padding-top: 30px;
    padding-bottom: 160px;

    h1 {
      font-size: 11.5vw;
      line-height: 15vw;
    }
  }
`;

export const DiveInto = styled.div`
  max-width: 580px;

  @media only screen and (max-width: 850px) {
    div {
      padding-top: 20px;
    }

    max-width: none;
  }
`;

export const WorkWithUs = styled.div`
  max-width: 260px;

  @media only screen and (max-width: 850px) {
    div {
      padding-top: 20px;
    }

    padding-top: 60px;
    max-width: none;
  }
`;
